import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  wrapper: {
    padding: "24px 24px 0 24px",
  },
  section: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    flexGrow: 1,
    padding: "24px",
    border: "1px solid #E4E7EC",
    borderRadius: 8,
  },
  title: {
    fontSize: "22px",
    lineHeight: "28px",
    letterSpacing: "0.15000000596046448px",
    textAlign: "left",
    fontWeight: 600,
    fontFamily: "Manrope",
  },
  subtitle: {
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: "0.15000000596046448px",
    textAlign: "left",
    fontWeight: 700,
    fontFamily: "Manrope",
  },
  descriptionContainer: {
    marginBottom: "24px",
  },
  description: {
    fontSize: "14px",
    lineHeight: "20px",
    letterSpacing: "0.25px",
    textAlign: "left",
    maxWidth: "619px",
    color: "#475467",
    fontWeight: 400,
    fontFamily: "Manrope",
  },
  inputImageContainer: {
    width: "320px",
    height: "160px",
    backgroundColor: "transparent",
    backgroundImage: `url(
      "data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%23E4E7ECFF' stroke-width='2' rx='14' ry='14' stroke-dasharray='30%2c 22' stroke-dashoffset='27' stroke-linecap='round'/%3e%3c/svg%3e")`,
    borderRadius: "12px",
  },
  actionButtons: {
    marginTop: 12,
    width: "100%",
  },
  button: {
    cursor: "pointer",
  },
}));

export default styles;
